export function withJustAdded<Key extends string>(
  added: Array<{ key: Key; values: string[] }>,
  justAdded: Key | null,
): Array<{ key: Key; values: string[] }> {
  if (justAdded === null) return added;
  if (added.some((filter) => filter.key === justAdded)) return added;
  return [...added, { key: justAdded, values: [] }];
}
